export function SiteResources() {
  return <section className="panel">
    <h2>Official site resources</h2>
    <p>Review the confirmed municipality's zoning ordinance and zoning map. Save the source link or upload its PDF in Site intelligence so it remains with this property.</p>
    <div className="button-row">
      <a className="button secondary" href="https://anr.vermont.gov/maps-and-mapping" target="_blank" rel="noopener noreferrer">Vermont Natural Resources Atlas + maps</a>
      <a className="button secondary" href="https://anr.vermont.gov/maps-and-mapping/biofinder" target="_blank" rel="noopener noreferrer">Vermont BioFinder</a>
    </div>
    <p className="fine">These resources open separately. A mailing address or ZIP code does not confirm the parcel's municipal jurisdiction.</p>
  </section>;
}
